import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  GET_EMPLOYEES_DATA,
  FETCH_DROPDOWN_DATAS,
  STATUS_UPDATE,
  GENERATE_ONBOARDING_LINK,
  DEPARTMENT_DROPDOWN,
  TEAM_DROPDOWN,
  ROLE_DROPDOWN,
  REPORTING_MANAGER_DROPDOWN,
  CITIES_DROPDOWN,
  ZONES_DROPDOWN,
  AREAS_DROPDOWN,
  ASSIGN_LOCATION,
  ASSIGN_REPORTEE,
  USER_LOCATION_MAPPING,
  USER_TEAM_MAPPING,
  DELETE_USER_MAPPING,
} from "./type";

export const getoffRoleEmployeesData =
  (page = 1, status = [], userId = null, filter = null, type = "") =>
  async (dispatch) => {
    let url = `${Config.offRoleEmployees.getOffRoleEmployeesList}?page=${page}`;

    if (status.length > 0) {
      url += `&status=${status}`;
    }

    if (type !== "") {
      if (type === "USER") {
        url += `&user_id=${encodeURIComponent(userId)}`;
      } else if (type === "OFFROLE") {
        url += `&id=${encodeURIComponent(userId)}`;
      }
    }

    if (filter && typeof filter === "object") {
      Object.keys(filter).forEach((key) => {
        if (filter[key] !== null && filter[key] !== "") {
          url += `&${encodeURIComponent(key)}=${encodeURIComponent(
            filter[key]
          )}`;
        }
      });
    }

    const res = await callWebService(callTypes.get, "", url);

    if (res) {
      const { data } = res;
      dispatch({ type: GET_EMPLOYEES_DATA, payload: data });
      return data.response;
    }
  };

export const getDataForDropdown = () => async (dispatch) => {
  let url = Config.offRoleEmployees.fetchDropdownDatas;

  const res = await callWebService(callTypes.get, "", url);
  if (res) {
    const { data } = res;
    dispatch({ type: FETCH_DROPDOWN_DATAS, payload: data });
    return data.response;
  }
};

export const updateStatusOffroleEmployee = (data) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.patch,
      data,
      `${Config.offRoleEmployees.updateActionByBusinessHead}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: STATUS_UPDATE,
        payload: data,
      });
      return data.response;
    }
  } catch {
    return false;
  }
};

export const generateLinkForOnboarding = (data) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.post,
      data,
      `${Config.offRoleEmployees.generateOnboardingLink}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: GENERATE_ONBOARDING_LINK,
        payload: data,
      });
      return data.response;
    }
  } catch {
    return false;
  }
};

export const departmentDropdownData = () => async (dispatch) => {
  let url = Config.offRoleEmployees.departmentDropdown;

  const res = await callWebService(callTypes.get, "", url);
  if (res) {
    const { data } = res;
    dispatch({ type: DEPARTMENT_DROPDOWN, payload: data });
    return data.response;
  }
};

export const teamDropdownData = (departmentId) => async (dispatch) => {
  let url = Config.offRoleEmployees.teamDropdown;
  url += `?department_id=${departmentId}`;

  const res = await callWebService(callTypes.get, "", url);

  if (res) {
    const { data } = res;
    dispatch({ type: TEAM_DROPDOWN, payload: data });
    return data.response;
  }
};

export const roleDropdownData = (departmentId) => async (dispatch) => {
  let url = Config.offRoleEmployees.roleDropdown;
  url += `?department_id=${departmentId}`;

  const res = await callWebService(callTypes.get, "", url);
  if (res) {
    const { data } = res;
    dispatch({ type: ROLE_DROPDOWN, payload: data });
    return data.response;
  }
};

export const reportingManagerDropdownData =
  (departmentId, teamId, roleLevel) => async (dispatch) => {
    let url = Config.offRoleEmployees.reportingManagerDropdown;
    url += `?department_id=${departmentId}&team_id=${teamId}&role_level=${roleLevel}`;

    const res = await callWebService(callTypes.get, "", url);
    if (res) {
      const { data } = res;
      dispatch({ type: REPORTING_MANAGER_DROPDOWN, payload: data });
      return data.response;
    }
  };

export const citiesDropdownData = () => async (dispatch) => {
  let url = Config.offRoleEmployees.citiesDropdown;

  const res = await callWebService(callTypes.get, "", url);
  if (res) {
    const { data } = res;
    dispatch({ type: CITIES_DROPDOWN, payload: data });
    return data.response;
  }
};

export const zonesDropdownData = (cityIds) => async (dispatch) => {
  let url = Config.offRoleEmployees.zonesDropdown;

  const res = await callWebService(callTypes.post, { city_id: cityIds }, url);

  if (res) {
    const { data } = res;
    dispatch({ type: ZONES_DROPDOWN, payload: data });
    return data.response;
  }
};

export const areasDropdownData = (zoneIds) => async (dispatch) => {
  let url = Config.offRoleEmployees.areasDropdown;

  const res = await callWebService(callTypes.post, { zone_id: zoneIds }, url);

  if (res) {
    const { data } = res;
    dispatch({ type: AREAS_DROPDOWN, payload: data });
    return data.response;
  }
};

export const assignLocationsToUser = (data) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.patch,
      data,
      `${Config.offRoleEmployees.assignLocations}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: ASSIGN_LOCATION,
        payload: data,
      });
      return data.response;
    }
  } catch {
    return false;
  }
};

export const assignReporteeToUser = (data) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.patch,
      data,
      `${Config.offRoleEmployees.assignReportee}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: ASSIGN_REPORTEE,
        payload: data,
      });
      return data.response;
    }
  } catch {
    return false;
  }
};

export const getLocationMappingByUserId = (userId) => async (dispatch) => {
  let url = Config.offRoleEmployees.fetchUserLocationMapping;
  url += `?user_id=${userId}`;

  const res = await callWebService(callTypes.get, "", url);
  if (res) {
    const { data } = res;
    dispatch({ type: USER_LOCATION_MAPPING, payload: data });
    return data?.response;
  }
};

export const getTeamMappingByUserId = (userId) => async (dispatch) => {
  let url = Config.offRoleEmployees.fetchUserTeamMapping;
  url += `?user_id=${userId}`;

  const res = await callWebService(callTypes.get, "", url);
  if (res) {
    const { data } = res;
    dispatch({ type: USER_TEAM_MAPPING, payload: data });
    return data?.response;
  }
};

export const deleteUserMappingRequest = (data) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.delete,
      data,
      `${Config.offRoleEmployees.deleteUserMapping}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: DELETE_USER_MAPPING,
        payload: data,
      });
      return data.response;
    }
  } catch {
    return false;
  }
};
